<footer class="quotation-footer">
  <div class="footer-content">
    <div class="footer-bottom" @fadeIn>
      <div class="copyright">
        <p>© {{ currentYear }} KIKBLOX Quotation Management System. All rights reserved.</p>
      </div>
      <div class="footer-contact">
        <p><i class="pi pi-envelope"></i> <a href="mailto:info&#64;kikblox.com">info&#64;kikblox.com</a></p>
      </div>
      <div class="footer-nav">
        <a href="#">Privacy Policy</a>
        <a href="#">Terms of Service</a>
        <a href="#">Sitemap</a>
      </div>
    </div>

    <div class="floating-action-button" @pulseAnimation (click)="scrollToTop()">
      <i class="pi pi-arrow-up"></i>
    </div>
  </div>
</footer>